import { useEffect, useState } from 'react'
import { Row, Col } from 'antd'
import AppLayout from '../../components/layout/layout'
import { Tabs } from 'antd'
import Statusmodal from '../../helper/Statusmodal'
import OrganizerTable from './Table/OrganizerTable'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateOrganizerStatus, useGetOrganizers } from '../../api/Organizers'
import ActionHeaders from './Headers/ActionHeader'
import Spinner from '../../components/Spinner'
import PageNameHeader from './Headers/PageNameHeader'
import { deleteOrganizer } from '../../api/Organizers'
import { forceRefetch } from '../../helper/utility'
import { organizerStore } from 'state/organizer/organizer'
import CreateOrganizer from './Modals/CreateOrganizer'
import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'
const { TabPane } = Tabs

const Organizer = () => {
  const organizerModalVisible = organizerStore(
    store => store.organizerModalVisible,
  )
  const [selectedRows, setSelectedRows] = useState([])
  const [parms, setParms] = useState<any>({})
  const { isLoading, data, refetch, isFetching } = useGetOrganizers(parms)
  const [activeData, setActiveData] = useState<any[]>([])
  const queryClient = useQueryClient()
  const { updateRouteParams } = useSyncParamsWithRoute(parms, setParms)

  function callback(key: any) {
    if (key == 'active') {
      updateRouteParams({
        ...parms,
        status: 'active',
        page: 1,
        queryString: undefined,
      })
    } else if (key == 'inactive') {
      updateRouteParams({
        ...parms,
        status: 'inactive',
        page: 1,
        queryString: undefined,
      })
    } else if (key == 'archived') {
      updateRouteParams({
        ...parms,
        status: 'archived',
        page: 1,
        queryString: undefined,
      })
    }
  }
  useEffect(() => {
    if (parms.page && parms.status) {
      refetch()
    }
  }, [parms])
  const deleteMutation = useMutation({
    mutationFn: async ({ id }: any) => {
      return await deleteOrganizer(id)
    },
    // Refetch only AFTER the archive completes — otherwise the list reloads before
    // the server updates and the row stays in Active until a manual refresh.
    onSuccess: () => {
      refetch()
    },
  })
  const deleteOrganizars = (id: any) => {
    deleteMutation.mutate({ id })
  }
  const [alertModalVisible, setAlertModalVisible] = useState(false)
  const deleteMultipleRecords = () => {
    let _data = [...activeData]
    selectedRows.forEach((row: any) => {
      _data = _data.filter(t => t.id !== row.key)
    })
    setActiveData(_data)
  }
  const alertModalData = {
    heading: 'Status changed',
    message1: 'Save',
  }

  const changeMutation = useMutation({
    mutationFn: async ({ params, payload }: any) => {
      return await updateOrganizerStatus(params, payload)
    },
    onSuccess: () => {
      forceRefetch('getOrganizers', queryClient)
      refetch()
    },
  })

  const [hiddenColumns, setHiddenColumns] = useState<any>({
    name: true,
    organizations: true,
    phone: true,
    email: true,
    status: true,
    action: true,
  })
  const handleSearch = (query: string) => {
    setParms({
      ...parms,
      queryString: query,
    })
  }
  const handleSort = (
    sortInfo: 'createdAt' | 'updatedAt' | '-createdAt' | 'name' | 'email',
  ) => {
    setParms({
      ...parms,
      sort: sortInfo,
    })
  }

  return (
    <AppLayout>
      <PageNameHeader
        selectedRows={selectedRows}
        setAlert={setAlertModalVisible}
        CSdata={data?.records}
        deleteMulti={deleteMultipleRecords}
      />
      <Row>
        <Col style={{ width: '100%' }}>
          <Tabs
            className="orgn-tabs"
            activeKey={
              parms.status === 'active'
                ? 'active'
                : parms.status === 'inactive'
                ? 'inactive'
                : parms.status === 'archived'
                ? 'archived'
                : ''
            }
            onChange={callback}
          >
            <TabPane tab="Active" key={'active'}>
              <ActionHeaders
                setCols={setHiddenColumns}
                hidCols={hiddenColumns}
                search={handleSearch}
                setParms={setParms}
                sort={handleSort}
                data={activeData}
                deleteMulti={deleteMultipleRecords}
              />
              <Row>
                <Col style={{ alignItems: 'center', width: '100%' }}>
                  {isLoading || isFetching ? (
                    <div
                      className="flex justify-center aligin-center items-center "
                      style={{ height: '80vh' }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    <OrganizerTable
                      activeData={data}
                      deleteRecord={deleteOrganizars}
                      setSelectedRows={setSelectedRows}
                      hidCols={hiddenColumns}
                      parmsData={parms}
                      setParms={setParms}
                      status="active"
                      changeStatus={changeMutation}
                      refetchOrganizers={() => {}}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Pending" key={'inactive'}>
              <ActionHeaders
                setCols={setHiddenColumns}
                hidCols={hiddenColumns}
                setParms={setParms}
                search={handleSearch}
                sort={handleSort}
              />
              <Row style={{ width: '100%' }}>
                <Col style={{ alignItems: 'center', width: '100%' }}>
                  {isLoading || isFetching ? (
                    <div
                      className="flex justify-center aligin-center items-center "
                      style={{ height: '80vh' }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    <OrganizerTable
                      activeData={data}
                      deleteRecord={deleteOrganizars}
                      setSelectedRows={setSelectedRows}
                      hidCols={hiddenColumns}
                      parmsData={parms}
                      setParms={setParms}
                      status="inactive"
                      changeStatus={changeMutation}
                      refetchOrganizers={() => {}}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Archived" key={'archived'}>
              <ActionHeaders
                setCols={setHiddenColumns}
                hidCols={hiddenColumns}
                setParms={setParms}
                search={handleSearch}
                sort={handleSort}
              />
              <Row style={{ width: '100%' }}>
                <Col style={{ alignItems: 'center', width: '100%' }}>
                  {isLoading || isFetching ? (
                    <div
                      className="flex justify-center aligin-center items-center "
                      style={{ height: '80vh' }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    <OrganizerTable
                      activeData={data}
                      deleteRecord={deleteOrganizars}
                      setSelectedRows={setSelectedRows}
                      hidCols={hiddenColumns}
                      parmsData={parms}
                      setParms={setParms}
                      status="archived"
                      changeStatus={changeMutation}
                      refetchOrganizers={() => {}}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Col>
      </Row>
      {alertModalVisible && (
        <Statusmodal
          isModalVisible={alertModalVisible}
          setIsModalVisible={setAlertModalVisible}
          data={alertModalData}
          name="organizer"
          selectedRows={selectedRows}
        ></Statusmodal>
      )}

      {/* modals  */}
      {organizerModalVisible && <CreateOrganizer />}
    </AppLayout>
  )
}

export default Organizer
